import { PublicKey } from "@solana/web3.js";
import { deserializeUnchecked, serialize } from "borsh";
import { Community } from "./community";
import { HapiAccountType } from "./enums";
class NetworkState {
    constructor(object) {
        Object.assign(this, object);
    }
}
NetworkState.schema = new Map([
    [
        NetworkState,
        {
            kind: "struct",
            fields: [
                ["account_type", "u8"],
                ["name", "string"],
            ],
        },
    ],
]);
NetworkState.size = 33;
export class Network {
    constructor(object) {
        /// HAPI account type
        this.accountType = HapiAccountType.Network;
        if (object) {
            Object.assign(this, object);
        }
    }
    static async getAddress(programId, communityAddress, networkName) {
        return PublicKey.findProgramAddress([
            Buffer.from("network"),
            communityAddress.toBuffer(),
            Buffer.from(networkName),
        ], programId);
    }
    static fromState(state) {
        const network = new Network();
        network.accountType = state.account_type;
        network.name = state.name;
        return network;
    }
    static deserialize(buffer) {
        return Network.fromState(deserializeUnchecked(NetworkState.schema, NetworkState, buffer));
    }
    static async retrieve(programId, connection, communityName, networkName) {
        const [communityAddress] = await Community.getAddress(programId, communityName);
        const [networkAddress] = await Network.getAddress(programId, communityAddress, networkName);
        const account = await connection.getAccountInfo(networkAddress);
        if (!account) {
            throw new Error(`Network not found: "${networkName}" (${networkAddress}) in community "${communityName}" (${communityAddress})`);
        }
        return { data: Network.deserialize(account.data), account: networkAddress };
    }
    serialize() {
        const buf = Buffer.alloc(NetworkState.size);
        buf.set(serialize(NetworkState.schema, this.toState()));
        return buf;
    }
    toState() {
        return new NetworkState({
            account_type: this.accountType,
            name: this.name,
        });
    }
}
Network.size = NetworkState.size;
//# sourceMappingURL=network.js.map